import { render, staticRenderFns } from "./ForgetPWDone.vue?vue&type=template&id=6615fc2a&"
import script from "./ForgetPWDone.vue?vue&type=script&lang=js&"
export * from "./ForgetPWDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports